import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  setSelectOptions,
  setSelectLoading,
  setSelectError,
} from "../../store/doctor/selectOptionsSlice";
import { translations } from "../../helpers";

export const useSelectOptionsStore = () => {
  const dispatch = useDispatch();

  const { protocols, patienSurgeryStates } = useSelector(
    (state) => state.doctor.selectOptions
  );

  const getProtocols = useCallback(async () => {
    try {
      dispatch(setSelectLoading({ key: "protocols" }));

      const { data } = await gosafeApi.get(`protocol`);

      dispatch(setSelectOptions({ key: "protocols", data }));

      return;
    } catch (error) {
      dispatch(
        setSelectError({
          key: "protocols",
          message:
            translations[error?.response?.data?.message] ||
            error?.response?.data?.message ||
            error?.message,
        })
      );
      return;
    }
  }, [dispatch]);

  return {
    // Props
    protocols,
    patienSurgeryStates,

    // Methods
    getProtocols,
  };
};
